import Cookies from "js-cookie";
import { store } from "./app/store";
import { setToken as setAuthTokenReducer } from "./features/sessionSlice";
export function setAuthorizationToken(token) {
    localStorage.setItem("igToken", token);
    store.dispatch(setAuthTokenReducer(token));
}
export function removeAuthorizationToken() {
    if (process.env.NODE_ENV !== "development") {
        localStorage.removeItem("igToken");
        store.dispatch(setAuthTokenReducer(null));
    }
}
export function getAuthorizationToken() {
    return localStorage.igToken;
}
export function setAuthorizationCookie(token) {
    Cookies.set("ig-authorization", token, {
        expires: 30,
        sameSite: "strict",
        secure: document.location.protocol === "https:",
        path: "/",
        domain: document.location.hostname,
    });
}
